import postcodeSaga from './postcodeSaga'
import clinicSaga from './clinicSaga'
import pricingSaga from './pricingSaga'

const billingGuideSagas = [...postcodeSaga, ...clinicSaga, ...pricingSaga]

export default billingGuideSagas
